export default __webpack_public_path__ + "static/media/servicies-call-agency.icon.c0551c9e.svg";